import React, { useEffect, useState, useContext } from "react";
import AddUser from "./Users/Add";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import UserList from "./Users/UserList";
import Search from "./Users/Search";
import Hierarchy from "./Users/Hierarchy";
import helpers from "../utils/helpers";
import constants from "../utils/constants";
import { compact, isEmpty, startCase } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrophoneLines } from "@fortawesome/free-solid-svg-icons";
import { isMobile } from "react-device-detect";
import moment from "moment";
const Home = () => {
  const location = useLocation();
  const user_params = compact(location.pathname.split("/"));
  let { user } = useContext(AuthContext);
  let user_by_created = user.id;
  let userType = user.userType;
  if (!isEmpty(user_params[0])) {
    user_by_created = user_params[0];
  }
  if (!isEmpty(user_params[1])) {
    userType = user_params[1];
  }
  const [show_model, setShowModel] = useState(false);
  const [reset, setRest] = useState(false);
  const [results, setResults] = useState([]);
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 100,
    keyword: "",
    status: "active",
    created_by: user_by_created,
    userType: userType,
  });
  const [balance, setBalance] = useState({
    totalAvailableLimit: 0,
    totalAmount: 0,
    totalCoins: 0,
    playerBalance: 0,
    availableLimit: 0,
    exposure: 0,
  });

  const onSubmit = (params) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: 1,
        keyword: params.keyword,
        status: params.status,
      };
    });
  };

  const handlePageClick = (event) => {
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: event.selected + 1,
      };
    });
  };
  const safeToFixed = (val, precision = 2) =>
    val != null && !isNaN(val) ? Number(Number(val).toFixed(precision)) : 0.0;

  const getUsers = async (obj) => {
    if (isEmpty(obj)) {
      document.getElementById("loading").style.display = "block";
    }
    const { status, data: response_users } = await apiGet(
      apiPath.downLineList,
      !isEmpty(obj) ? obj : search_params
    );
    if (status === 200) {
      if (response_users.success) {
        setResults(response_users?.results || []);
        if ("balance" in response_users?.results) {
          setBalance((prevState) => {
            const balance_info = response_users?.results?.balance;
            return {
              ...prevState,
              totalAvailableLimit: safeToFixed(
                balance_info.totalAvailableLimit
              ),
              totalAmount: safeToFixed(balance_info.totalAmount),
              totalCoins: safeToFixed(balance_info.totalCoins),
              playerBalance: safeToFixed(balance_info.playerBalance),
              availableLimit: safeToFixed(balance_info.availableLimit),
              exposure: safeToFixed(balance_info.exposure),
              playerExposure: safeToFixed(balance_info.playerExposure),
              finalPL: safeToFixed(balance_info.finalPL),
            };
          });
        }
      }
    }
    document.getElementById("loading").style.display = "none";
    setRest(false);
  };
  console.log("balance_info", balance);
  const resetList = () => {
    setRest(true);
    setSearchParams((prevState) => {
      return {
        ...prevState,
        page: 1,
        page_size: 10,
        keyword: "",
        status: "active",
      };
    });
  };

  const refreshUsers = () => {
    getUsers();
  };

  useEffect(() => {
    const user_params = compact(location.pathname.split("/"));
    let user_by_created = user.id;
    if (!isEmpty(user_params[0])) {
      user_by_created = user_params[0];
      setSearchParams((prevState) => {
        return {
          ...prevState,
          page: 1,
          page_size: 10,
          keyword: "",
          status: "active",
          created_by: user_by_created,
          userType: userType,
        };
      });
    } else {
      setSearchParams((prevState) => {
        return {
          ...prevState,
          page: 1,
          page_size: 10,
          keyword: "",
          status: "active",
          created_by: user.id,
          userType: user?.userType,
        };
      });
    }
  }, [location]);

  useEffect(() => {
    getUsers();
  }, [
    search_params?.page,
    search_params?.keyword,
    search_params?.status,
    search_params?.created_by,
    search_params?.userType,
  ]);

  const [message, setMessage] = useState([]);
  const messageList = async () => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    hostname = hostname || "sabaexch.com";
    const { status, data: response_users } = await apiGet(
      apiPath.messageList + "&domain=" + hostname
    );
    if (status === 200) {
      if (response_users.success) {
        setMessage(response_users.results);
      }
    }
  };
  useEffect(() => {
    messageList();
  }, []);

  useEffect(() => {
    const intervalID = setInterval(() => {
      getUsers(search_params);
    }, 30 * 1000);

    return () => clearInterval(intervalID);
  }, [search_params]);

  const availableBalance =
    (balance?.totalAmount &&
      Math.abs(balance?.totalAmount) - Math.abs(balance?.playerExposure)) ||
    0;
  return (
    <div className="top-header-inner">
      <div
        className={`${
          isMobile ? "newsBlock-new newsBlock mb-2" : " newsBlock mb-2"
        }`}
      >
        <div
          style={{ display: "flex", alignItems: "center", padding: "0 10px" }}
          className="newsBlock-div"
        >
          <FontAwesomeIcon
            icon={faMicrophoneLines}
            style={{ marginRight: "3px" }}
          />{" "}
          News {/* <span className="triangle ms-3"></span> */}
        </div>

        <marquee width="100%" className="newsFlash news">
          {message?.map((res) => {
            return (
              // <div className="newItems">
              //   <span>
              //     {" "}
              //     {helpers.msgDateFormat(res.msgDate, user.timeZone)}
              //   </span>{" "}
              //   {res.title} - {res.message}
              // </div>
              <a href="javascript:void(0)" style={{ marginRight: "10px" }}>
                <span>{moment(res.msgDate).format("DD MMM YYYY")}</span>
                {res.title} - {res.message}
              </a>
            );
          })}
        </marquee>
      </div>

      <section className="find-member-sec py-3">
        <Container fluid className="px-0">
          <Row>
            <Col xl={12} className="mb-md-0 mb-3">
              <Row>
                <Col xl={6} lg={7} md={12} className="">
                  <Search
                    onSubmit={onSubmit}
                    search_params={search_params}
                    reset={reset}
                  />
                </Col>

                <Col xl={6} lg={5} md={12}>
                  <div
                    className="d-flex flex-wrap justify-content-between"
                    style={{ marginLeft: `-30px` }}
                  >
                    <Hierarchy results={results} />
                    <div className="find-member-director text-xl-end ">
                      {(user_params?.length == 0 ||
                        user?.userType == "sub_owner") && (
                        <a
                          href="javascript:void(0)"
                          className="btn add_member"
                          style={{ fontWeight: "bold" }}
                          onClick={() => {
                            setShowModel(!show_model);
                          }}
                        >
                          Add{" "}
                          {/* <i className="fas fa-user-plus pe-1"></i> Add{" "} */}
                          {startCase(
                            constants.user_next_status_only_status[
                              !isEmpty(user_params[1])
                                ? user_params[1]
                                : user?.userType
                            ]
                          )}
                        </a>
                      )}
                      <a
                        href="javascript:void(0)"
                        style={{ minWidth: "auto" }}
                        className="btn"
                        onClick={resetList}
                      >
                        {" "}
                        <i
                          style={{ transform: "scale(-1,1)" }}
                          className="fas fa-redo-alt"
                        ></i>
                      </a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="total-balance-sec">
        <Container fluid className="px-0">
          <ul className="list-unstyled">
            <li>
              <dt>Total Balance</dt>
              <strong>
                PBU {`${helpers.currencyFormat(balance?.totalAmount)}`}
              </strong>
            </li>
            <li>
              <dt>Total Exposure</dt>
              <strong>
                PBU{" "}
                <span
                  className={balance?.playerExposure > 0 ? "text-danger" : ""}
                >
                  {balance?.playerExposure > 0
                    ? `(${helpers.currencyFormat(balance?.playerExposure)})`
                    : helpers.currencyFormat(balance?.playerExposure)}
                </span>
              </strong>
            </li>

            <li>
              <dt>Total Avail. bal.</dt>
              <strong>
                PBU {`${helpers.currencyFormat(availableBalance)}`}
              </strong>
            </li>

            <li>
              <dt>Balance</dt>
              <strong>
                PBU {`${helpers.currencyFormat(balance?.totalCoins)}`}
              </strong>
            </li>

            <li>
              <dt>Available Balance</dt>
              <strong>
                PBU{" "}
                {`${helpers.currencyFormat(
                  Math.abs(balance?.totalAmount) + balance?.totalCoins
                )}`}
              </strong>
            </li>
            {results?.data?.length > 0 &&
              results?.data[0]?.userType !== "user" && (
                <li>
                  <dt>Transferable P/L with Upline</dt>
                  <strong>
                    PBU{" "}
                    <span className="text-danger">
                      ({`${helpers.currencyFormat(Math.abs(balance?.finalPL))}`}
                      )
                    </span>
                  </strong>
                </li>
              )}
            <li>
              <dt>Total User</dt>
              <strong>{results?.data?.length}</strong>
            </li>
          </ul>
        </Container>
      </section>

      <UserList
        results={results}
        handlePageClick={handlePageClick}
        getUsers={getUsers}
        data={user.userType}
        allow_domain_access={user?.allow_domain_access}
      />
      <div id="descFooter" class="footer-sticky justify-end space-x-1">
        {user?.userType !== "user" && (
          <>
            <div class="btn-footer">
              {/* <i className="fas fa-lock"></i> */}
              <img src="../assets/images/bank.png"></img>
            </div>
            <p>Bank</p>
          </>
        )}

        <div class="btn-footer">
          {/* <i className="fas fa-exchange-alt swap-icon"></i> */}
          <img src="../assets/images/p_l.png"></img>
        </div>
        <p>Betting Profit &amp; Loss</p>
        <div class="btn-footer">
          {/* <i className="fas fa-th-list"></i> */}
          <img src="../assets/images/betting_history.png"></img>
        </div>
        <p>Betting History</p>
        <div class="btn-footer">
          {/* <i className="fas fa-user"></i> */}

          <img src="../assets/images/person.png"></img>
        </div>
        <p>Profile</p>
        {(user.userType == "super_admin" ||
          user.userType == "sub_owner" ||
          user.userType == "owner") && (
          <>
            <div class="btn-footer">
              {/* <i className="fas fa-cog"></i> */}
              <img src="../assets/images/status.png"></img>
            </div>
            <p>Change Status</p>
          </>
        )}
      </div>
      {show_model ? (
        <AddUser
          refreshUsers={refreshUsers}
          id={user_params[0] ? user_params[0] : user._id}
          slug={user_params[1] ? user_params[1] : user.userType}
          setShowModel={() => {
            setShowModel(!show_model);
          }}
        />
      ) : null}
    </div>
  );
};

export default Home;
